import {LoggingFacade} from '@vwdfive/myvw-logging';
import {DocumentConsentClient, IDocumentConsentResponse} from './DocumentConsentClient';

export class DocumentConsentService {
    constructor(private readonly documentConsentClient: DocumentConsentClient, private readonly loggingFacade: LoggingFacade) {
    }

    public async getDocumentConsentRequired(isWcar: boolean, documentId: string, userId: string): Promise<IDocumentConsentResponse | undefined> {
        try {
            return await this.documentConsentClient.getDocumentConsentRequired(isWcar, documentId, userId);
        } catch (error) {
            this.loggingFacade.error(`Could not fetch document from document-consent for id ${documentId}`, error as Error);
            return undefined;
        }
    }
}